import { faMinus, faWarning } from '@fortawesome/free-solid-svg-icons';
import type { ExpirationColumnProps } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useExpiryClassification } from '../../../lib/hooks';
import { BulmaType, formatDate, Tag } from '@easylife365/react';

const ExpirationColumn: React.FC<ExpirationColumnProps> = ({ isSaml, targetDate }) => {
  const { isAboutToExpire, isExpired } = useExpiryClassification();

  if (!targetDate) return <FontAwesomeIcon icon={faMinus} style={{ justifySelf: 'center' }} />;

  const expired = isExpired(targetDate);
  const aboutToExpire = isAboutToExpire(targetDate, isSaml);

  const titleDate = formatDate(targetDate, {
    useRelativeTime: false,
    formatOptions: {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
    },
  });

  return (
    <Tag
      additionalCss="text"
      {...(expired || aboutToExpire ? { icon: faWarning } : {})}
      label={formatDate(targetDate)}
      title={titleDate}
      bulmaType={expired ? BulmaType.Danger : aboutToExpire ? BulmaType.Warning : BulmaType.Success}
    />
  );
};

export default ExpirationColumn;
